import React from 'react';

import './GeneratingRobot.scss';

/**
 * GeneratingRobot - a LoadingRobot variant for the custom practice flow (TANAI-1869).
 *
 * Shows the tenant's "generating" bot illustration with a gentle floating animation.
 * The image comes from the `--tangerine-ai-bot-generating` CSS var (defined per tenant
 * in `public/css/styles.css` and `public/edelvives/css/styles.css`), so Edelvives etc.
 * swap the asset automatically. Unlike the shared `LoadingRobot` (a fixed full-screen
 * overlay), this is sized to sit inside the generating dialog; the caption lives in the
 * dialog header.
 */

function GeneratingRobot(): JSX.Element {
  return (
    <div className="generating-robot">
      <span aria-hidden="true" className="generating-robot__image" />
    </div>
  );
}

export default GeneratingRobot;
